import CRMSendMessageByWazzupForm from './CRMSendMessageByWazzupForm';

export default CRMSendMessageByWazzupForm;
